<template>
  <div>
    <div id="entirety">
      <div id="headNav">
        <h6 class="head_text" @click="isCollapse = !isCollapse">权益金管理平台</h6>
        <div style="margin-right: 4%">
          <div style="display: flex; width: 100%">
            <el-dropdown>
              <el-badge :value="readNUm ? readNUm.nums : 0" :max="99" class="item">
                <el-button type="text" icon="el-icon-message-solid" size="mini"
                  style=" font-size: 25px;color: white;top: -15px;position: relative;"
                  @click="noticeClick()"></el-button>
              </el-badge>
              <el-dropdown-menu slot="dropdown" style="max-height: 300px;" class="scrollHidden">
                <el-dropdown-item v-if="tableData.length == 0">现在还有收到通知</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown @command="handleCommand" style="color: white;font-size: 19px;">
              <span class="el-dropdown-link">
                {{ userName }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a">退出登录</el-dropdown-item>
                <el-dropdown-item command="b">修改密码</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <div style="display: flex; width: 100%; height: calc(100% - 60px)">
        <div id="sideNav" class="scrollHidden" v-if="!flagShow">
          <el-menu :default-active="$route.name" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
            active-text-color="#0055ff" background-color="#121212" text-color="#fff" router :collapse="isCollapse"
            unique-opened @select="select">
            <template v-for="(item, index) in myRouter || []">
              <el-menu-item :index="item.authRemark.substring(1)" :route="item.authUrl" v-if="!item.children">
                <i :class="item.authIcon"></i>
                <span slot="title">{{ item.authName }}</span>
              </el-menu-item>
              <el-submenu :index="`${index}`" v-if="item.children && item.children.length > 0">
                <template slot="title">
                  <i :class="item.authIcon"></i>
                  <span>{{ item.authName }}</span>
                </template>
                <el-menu-item v-for="(items) in item.children || []" :key="items.authId" :index="items.authRemark"
                  :route="items.authUrl">
                  <i :class="items.authIcon"></i>
                  <span slot="title">{{ items.authName }}</span>
                </el-menu-item>
              </el-submenu>
            </template>
          </el-menu>

        </div>

        <div id="main">
          <keep-alive>
            <router-view @child-call="handlePictureCardPreview"></router-view>
          </keep-alive>
        </div>
      </div>
    </div>
    <el-dialog :title="conterstr.noticeTitle" :visible.sync="Isconter" width="70%" top="8vh">
      <div style="margin: 15px;">
        {{ conterstr.noticeContent }}
      </div>
      <p style="margin: 15px;">通知时间:{{ conterstr.createtime }}</p>
    </el-dialog>
    <el-dialog title="消息列表" :visible.sync="IsConterShow" width="70%" top="8vh">
      <div slot="title" style="width: 100%;margin: 0px auto 10px;display: flex;align-items: center;">
        消息列表:
        <el-button style="margin-left: 20px;" :plain="noticIndex == 1 ? false : true" type="primary"
          @click="noticeChange(1, 1)">商户待审核({{ readNUm.numsOne || 0}})</el-button>
        <el-button style="margin-left: 20px;" :plain="noticIndex == 2 ? false : true" type="primary"
          @click="noticeChange(1, 2)">对公待打款({{ readNUm.numsTwo || 0}})</el-button>
        <el-button style="margin-left: 20px;" :plain="noticIndex == 3 ? false : true" type="primary"
          @click="noticeChange(1, 3)">发票更换申请({{ readNUm.numsThree || 0}})</el-button>
        <el-button style="margin-left: 20px;" type="primary" :plain="noticIndex == 5 ? false : true"
          @click="noticeChange(2, 5)">通知信息({{ readNUm.numNotice || 0}})</el-button>
      </div>
      <div style="width: 100%">
        <div style="display: flex;justify-content: space-between;margin: 15px;" v-if="noticIndex == 5">
          <el-select v-model="formDatas.noticeTitle" placeholder="请选择标题" size="small" clearable @change="partserch">
            <el-option v-for="(item, index) in noticeTitleList || []" :label="item" :value="item" :key="index">
            </el-option>
          </el-select>
          <el-button type="danger" size="small" style="margin-right: 10px;" @click="readClick">一键已读</el-button>
        </div>
        <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
          :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
          :checkbox-option="checkboxOption" row-key-field-name="noticeId" :cellSelectionOption="cellSelectionOption"
          style="width: 100%" v-loading="tableLoading" element-loading-background="rgba(255, 255, 255, 0.9)"
          element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" custom-class="table-loading" />
        <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
      </div>
      <div class="table-pagination">
        <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
          :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
          @on-page-size-change="pageSizeChange" />
      </div>
    </el-dialog>
    <el-dialog title="修改密码" :visible.sync="updataPw" width="25%" center>
      <p>新密码</p>
      <el-input v-model="suPw" autocomplete="off"></el-input>

      <span slot="footer" class="dialog-footer">
        <el-button @click="updataPw = false; suPw = ''">取 消</el-button>
        <el-button type="primary" @click="updataPwclick">确 定</el-button>
      </span>
    </el-dialog>
    <el-image ref="scrImg" :src="dialogImageUrl" alt="" fit="fill"
      style="width: 100%;height: 0;position: fixed;bottom: 0px;left: 0px;" :preview-src-list="scrList"></el-image>
  </div>
</template>

<script>
import { calcTableHeight } from "../utils/tableHeight.js";
import {
  getSysNoticeList, getSysNoticeUnReadNum, deleteSysNoticeRead, updateSysNoticeRead, getAjefUserNoticeTotal,
  updateAjefUserPw, getAjefUserDetailsRefresh, getSysNoticeListTitle, updateSysNoticeReadAll,
} from "../api/api";
export default {
  name: "Home",
  data() {
    return {
      dialogImageUrl: '',
      scrList: [],
      noticIndex: 1,
      IsConterShow: false,
      noticeTitleList: [],
      myRouter: [],
      clickRouter: 'HomePage',
      iuId: '',
      suPw: '',
      updataPw: false,
      formDatasTwo: {},
      formDatas: {
        currentPage: 1,
        pageSize: 10,
      },
      columns: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          align: "center",
          fixed: 'left',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },

        {
          field: "noticeTitle",
          key: "noticeTitle",
          title: "标题",
          align: "center",
          width: 200,

        },
        {
          field: "noticeContent",
          key: "noticeContent",
          title: "内容",
          align: "center",


        },
        {
          field: "createtime",
          key: "createtime",
          title: "通知时间",
          align: "center",
          width: 200,

        },
        {
          field: "",
          key: "d",
          title: "操作",
          width: 200,
          fixed: 'right',
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {
                  row.noticeId && row.noticeStatus == 1 ? <el-button
                    size="mini"
                    type="text"
                    on-click={() => this.getRead(row)}
                  >
                    已读
                  </el-button> : ''
                }
                {
                  row.noticeId ? <el-button
                    size="mini"
                    type="text"
                    style="color: red"
                    on-click={() => this.deleteRead(row.noticeId)}
                  >
                    删除
                  </el-button> : ''
                }


              </span>
            );
          },
        }
      ],
      cellSelectionOption: {
        // disble cell selection
        enable: false,
      },
      totalCount: 100,
      pageIndex: 1,
      pageSize: 10,
      selectedRowKeysCollection: [],
      checkboxOption: {
        // 可控属性
        selectedRowKeys: [],
        // 行选择改变事件
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          this.changeSelectedRowKeys(row, isSelected);
        },
        // 全选改变事件
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          this.changeSelectAll(isSelected, selectedRowKeys);
        },
      },
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
      tableDataCopy: [],
      tableHight: 520,
      tableData: [],
      tableLoading: false,

      flag: '',
      flagShow: false,
      iuPost: '',
      Isconter: false,
      conterstr: '',
      userName: localStorage.getItem("Qy_userName"),
      readNUmArr: [],
      readNUm: '',
      isCollapse: false,
    };
  },
  created() {
    //console.log("首页");
    // this.iuId = localStorage.getItem("iuId");
    this.username = localStorage.getItem("Ai_userName");
    console.log(this.username);
    document.title = "权益金管理平台";
    this.iuPost = localStorage.getItem("Ai_userPost");
    getAjefUserDetailsRefresh().then(res => {
      if (res) {
        this.myRouter = res.data.ajefRoleAuthList;
        console.log(this.myRouter);
        const clickRouter = localStorage.getItem('Qy_path')
        if (this.myRouter && clickRouter) {
          this.clickRouter = clickRouter
          this.$router.push(clickRouter);
          // window.close();
        } else {
          const path = res.data.ajefRoleAuthList[0].children ? res.data.ajefRoleAuthList[0].children[0].authUrl : res.data.ajefRoleAuthList[0].authUrl
          this.$router.push(path);
          // window.close();
        }
      }
    })

    this.partserch();
    getSysNoticeListTitle().then(res => {
      if (res && res.data) {
        this.noticeTitleList = res.data
      }
    })
    getSysNoticeUnReadNum().then(res => {
      if (res.data == 0) {
        this.readNUm = '';
        return
      }
      this.readNUm = res.data
    })
  },
  watch: {},

  activated() {
    this.username = localStorage.getItem("iuName");
    document.title = "权益金管理平台";
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = calcTableHeight(this, this.windheight, 140);
    });
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = calcTableHeight(this, val, 140);
        }
      });
    },
    "$store.state.HomeNum"(val) {
      this.$nextTick(() => {
        this.getlist()
      });
    },
  },
  deactivated() {
    this.watchFlag = false;
    this.IsConterShow = false
  },
  methods: {
    openLoading() {
      //loading请求等待
      this.loadings = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
    },
    handlePictureCardPreview(file) {
      console.log(file);
      this.dialogImageUrl = file[0];
      this.$nextTick(() => {
        this.$refs.scrImg.clickHandler()
      })
      this.scrList = file;
    },
    noticeClick() {
      this.noticIndex = 1;
      this.getAjefUserNoticeTotal();
      this.IsConterShow = true;
    },
    readClick() {
      updateSysNoticeReadAll().then(res => {
        this.partserch()
      })
    },
    select(key, keyPath) {
      console.log(key, keyPath);
      localStorage.setItem('Qy_path', key);
    },
    updataPwclick() {
      if (this.suPw == '') {
        this.$message({
          type: 'warning',
          message: '请输入密码!'
        })
      } else {
        updateAjefUserPw({ auPw: this.suPw }).then(res => {
          this.$message({
            type: 'success',
            message: '修改成功!'
          })
          this.updataPw = false;
          this.suPw = '';

        })
      }
    },
    handleCommand(command) {
      if (command == "a") {
        this.Out()
      } else {
        this.updataPw = true;
      }
    },
    noticeChange(index, type) {
      this.formDatas.currentPage = 1;
      this.noticIndex = type;
      if (index == 1) {
        this.formDatasTwo.noticeType = type;
        this.getAjefUserNoticeTotal()
      } else {
        this.partserch()
      }
    },
    getAjefUserNoticeTotal() {
      this.openLoading()
      getAjefUserNoticeTotal(this.formDatasTwo).then(res => {
        this.tableData = res.data;
        this.tableDataCopy = res.data;
        this.totalCount = res.total || 0;
        this.loadings.close()
      })
    },
    partserch() {
      this.formDatas.currentPage = 1;
      this.formDatas.checkStatus = 2;
      this.tableLoading = true;
      getSysNoticeList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.tableDataCopy = res.data;
        this.totalCount = res.total;
        this.resetSelectedRowKeys();
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
      getSysNoticeUnReadNum().then(res => {
        if (res.data == 0) {
          this.readNUm = ''
          return
        }
        this.readNUm = res.data

      })
    },
    resetSelectedRowKeys() {
      //console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
      this.checkboxOption.selectedRowKeys = [];

      const selectedRowKeysCollection = this.selectedRowKeysCollection;

      if (selectedRowKeysCollection.length) {
        this.tableData.forEach((item) => {
          if (selectedRowKeysCollection.indexOf(item.auId) > -1) {
            //console.log(item);
            this.checkboxOption.selectedRowKeys.push(item.auId);
          }
        });
      }
    },
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.partserch();
    },
    pageNumberChange(pageIndex) {
      //console.log(pageIndex);
      this.formDatas.currentPage = pageIndex;
      this.formDatas.checkStatus = 2;
      this.tableLoading = true;
      getSysNoticeList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.tableDataCopy = res.data;
        this.totalCount = res.total;
        this.resetSelectedRowKeys();
        this.tableLoading = false;
        // this.$message({
        //     type: "success",
        //     message: "搜索成功!",
        // });
      }).catch(() => {
        this.tableLoading = false;
      });

    },
    getRead(val) {
      // this.conterstr = val;
      // this.Isconter = true;
      if (val.noticeStatus == 1) {
        updateSysNoticeRead({ noticeIds: val.noticeId }).then(res => {
          this.partserch()
        })
      }
    },
    getlist() {
      this.tableLoading = true;
      getSysNoticeList().then(res => {
        //console.log(res.data);
        this.readNUmArr = res.data;
        this.tableLoading = false;
      }).catch(() => {
        this.tableLoading = false;
      });
      getSysNoticeUnReadNum().then(res => {
        if (res.data == 0) {
          this.readNUm = ''
          return
        }
        this.readNUm = res.data

      })
    },
    deleteRead(id) {
      this.$confirm("删除后该通知不再显示, 巡检告警相同内容将不再提醒(金额变化会重新提醒), 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteSysNoticeRead({ noticeIds: id }).then(res => {
            this.partserch()
          })

        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        })
    },
    Out() {
      localStorage.clear();
      this.$router.push({
        path: "/doLogin",
      });
    },
    handleOpen(key, keyPath) {
    },


    handleClose(key, keyPath) {
      //console.log(key, keyPath);
    },
  },
};
</script>

<style scoped="scoped">
.item {
  position: absolute;
  top: 5px;
  right: 20px;
  margin-top: 15px;
  margin-right: 20px;
}

#entirety {
  width: 100%;
  height: 100vh;
}

#headNav {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #121212;
  display: flex;
  justify-content: space-between;
}

.scrollHidden {
  overflow-y: scroll;
}

.head_text {
  color: white;
  margin-left: 2em;
  font-size: 19px;
  margin-left: 2%;
  width: 45%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

#sideNav {
  /* width: 13%; */
  height: 100%;
  background-color: #121212;
  overflow-y: scroll;
  overflow-x: hidden;
}

#main {
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: hidden;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 230px;
  min-height: 400px;
}

div /deep/ .el-submenu__icon-arrow {
  right: 40px;
}

/* 隐藏滚动条 */
.scrollHidden::-webkit-scrollbar {
  display: none;
}
</style>
